import React from 'react';
import NextImage from '../NextImage';
import Button from '../Button';
import NextLink from '../NextLink';
import Dot from '@src/components/Icons/Dot';
import isEmpty from '@src/utils/isEmpty';
import dateFormatter from '@src/utils/dateFormatter';
import { PostEntryPropTypes } from './PostEntry.types';
import LanguageSwitcher from '../LanguageSwitcher';
const PostEntry: React.FC<PostEntryPropTypes> = ({
  locale,
  blog,
  searchParams = {},
  globalTextBlock
}) => {
  const path = locale?.toLowerCase() == 'en' ? `/news/${blog?.slug}` : `/${locale}/news/${blog?.slug}`;
  return <div className='pb-[2.4rem] lg:pb-[3.2rem]' data-sentry-component="PostEntry" data-sentry-source-file="PostEntry.tsx">
      <NextLink className='rounded-2xl' href={path} ariaLabel={blog?.title} data-sentry-element="NextLink" data-sentry-source-file="PostEntry.tsx">
        <NextImage className='h-auto w-full' src={blog?.thumbnail?.url ?? ''} alt={blog?.thumbnail?.description ?? ''} width={blog?.thumbnail?.width} data-sentry-element="NextImage" data-sentry-source-file="PostEntry.tsx" />
      </NextLink>
      <NextLink href={path} ariaLabel={blog?.title} className='mb-[0.8rem] mt-[1.2rem] line-clamp-3 text-[1.6rem] font-[600] leading-[2rem] text-body-copy--dark md:mt-[1.6rem] md:text-[1.8rem] md:leading-[2.25rem]' data-sentry-element="NextLink" data-sentry-source-file="PostEntry.tsx">
        {blog.title}
      </NextLink>

      <div className='mb-[1rem] flex flex-wrap items-center gap-[0.8rem] text-[1.4rem]'>
        <p className='font-normal text-body-copy--dark'>
          {!isEmpty({
          value: searchParams?.category
        }) ? blog?.categoriesCollection?.items?.find(item => {
          return item?.slug === searchParams?.category;
        })?.title : blog?.categoriesCollection?.items?.[0]?.title}
        </p>
        <Dot data-sentry-element="Dot" data-sentry-source-file="PostEntry.tsx" />
        {dateFormatter(blog?.datePublished)}
      </div>

      <div className='mb-[3rem] flex flex-wrap gap-[0.8rem]'>
        <LanguageSwitcher post={blog} data-sentry-element="LanguageSwitcher" data-sentry-source-file="PostEntry.tsx" />
      </div>

      <Button tertiary href={path} btnText={globalTextBlock?.items?.[0]?.learnMore} align='justify-start' data-sentry-element="Button" data-sentry-source-file="PostEntry.tsx" />
    </div>;
};
export default PostEntry;